/* For Best Practices https://facebook.github.io/create-react-app/docs/adding-custom-environment-variables*/
export const API_URL = 'https://devopsdemo.1cloudhub.com'
//'http://localhost:5000'
//export const API_URL = 'http://rest-api-qa.kvajmpmiiu.us-east-1.elasticbeanstalk.com'
export const JPA_API_URL = `${API_URL}/jpa`
